import { createStore } from "redux"
import reducers from "../_reducers"

export const store = createStore(
  reducers,
  /* Redux Dev Tools */
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
